var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exam" }, [
    _c("div", { staticClass: "count" }, [
      _vm.examPassState == "passed" && _vm.parent == "jineng" && _vm.voiceBadge
        ? _c("div", [
            _c("img", {
              staticClass: "textimg",
              attrs: {
                src:
                  "http://res.study.itaojin.cn/2020-11/7d643a6946e548d3b20c87b45516875b.png",
                alt: ""
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p"),
      _vm.examPassState == "passed" &&
      _vm.parent != "jineng" &&
      _vm.newPeopleBadge
        ? _c("div", { staticClass: "result-txt result-text" }, [
            _vm._v("你已通过该课程的学习与考试!")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.examPassState == "passed" && _vm.parent == "jineng" && _vm.voiceBadge
        ? _c("div", { staticClass: "result-txt result-text" }, [
            _vm._v("你已通过技能提升，现在可以去领任务了")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.examPassState == "passed" && _vm.isexamination == false
        ? _c("div", { staticClass: "result-txt result-text" }, [
            _vm._v("你已通过该课程！")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.examPassState == "failed"
        ? _c("span", { staticClass: "result-txt" }, [
            _vm._v("很遗憾您未通过考试")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _vm.examPassState == "failed"
        ? _c("div", { staticClass: "score-box" }, [
            _c("span", [
              _vm._v("测试分数："),
              _c("span", { staticClass: "num" }, [
                _vm._v(_vm._s(_vm.score) + "分")
              ])
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v("剩余测试机会："),
              _c("span", { staticClass: "num" }, [
                _vm._v(_vm._s(_vm.remainingExamTimes) + "次")
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.examPassState == "failed" || _vm.isexamination == false
        ? _c("div", { staticClass: "btn-box" }, [
            _c(
              "span",
              {
                staticClass: "relearn_button",
                on: { click: _vm.returnCourseList }
              },
              [_vm._v("点击重新学习")]
            ),
            _vm._v(" "),
            _c("span", { on: { click: _vm.beginExam } }, [_vm._v("再测一次")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.examPassState == "passed" && _vm.parent == "jineng" && _vm.voiceBadge
        ? _c("div", { staticClass: "btn-box" }, [
            _c("span", { on: { click: _vm.returnscene } }, [
              _vm._v("返回到场景")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7150910c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7150910c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/examResult.vue
// module id = 1592
// module chunks = 0